import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { store } from "./redux/store";

//notificaciones
import { NotificationContainer } from "react-notifications";

ReactDOM.render(
  <Router>
    <Provider store={store}>
      
      <App />
      <NotificationContainer />
    </Provider>
  </Router>,
  document.getElementById("root")
);

// Prueba If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
